(function () {
  const items = [];

  function init() {
    const follow = document.querySelectorAll('.cursor-follow');
    const opposite = document.querySelectorAll('.cursor-follow-opposite');

    follow.forEach(el => register(el, 1));
    opposite.forEach(el => register(el, -1));
  }

  function register(el, direction) {
    const strength = parseFloat(el.dataset.strength || 0.04);
    const axis = el.dataset.axis || 'both';

    items.push({
      el,
      direction,
      strength,
      axis,
      x: 0,
      y: 0,
      targetX: 0,
      targetY: 0
    });

    el.style.willChange = 'transform';
  }

  let mouseX = window.innerWidth / 2;
  let mouseY = window.innerHeight / 2;

  document.addEventListener('mousemove', e => {
    mouseX = e.clientX;
    mouseY = e.clientY;
  });

  function animate() {
    const cx = window.innerWidth / 2;
    const cy = window.innerHeight / 2;

    items.forEach(item => {
      const dx = (mouseX - cx) * item.strength * item.direction;
      const dy = (mouseY - cy) * item.strength * item.direction;

      item.targetX = item.axis === 'y' ? 0 : dx;
      item.targetY = item.axis === 'x' ? 0 : dy;

      // smooth interpolation
      item.x += (item.targetX - item.x) * 0.1;
      item.y += (item.targetY - item.y) * 0.1;

      item.el.style.transform = `translate3d(${item.x}px, ${item.y}px, 0)`;
    });

    requestAnimationFrame(animate);
  }

  document.addEventListener('DOMContentLoaded', () => {
    init();
    animate();
  });
})();
